/**
  * Check if a variable is a function
  * @param {any} fn variable to be checked
  * @returns {boolean}
*/
export default (fn) => typeof fn === 'function';
